// extracted by mini-css-extract-plugin
export var big = "styles-module--big--bdb43";
export var button = "styles-module--button--a58cb";
export var defaultButton = "styles-module--defaultButton--e5c4b";
export var primary = "styles-module--primary--467a9";
export var secondary = "styles-module--secondary--934ec";
export var small = "styles-module--small--2d4f4";